module.exports = __webpack_public_path__ + "static/media/Address.051b26ea.svg";